var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"lxmv",rawName:"v-lxmv",value:({ bid: _vm.mvbid, lab: _vm.lab }),expression:"{ bid: mvbid, lab }"}],attrs:{"href":_vm.iurl},on:{"click":function($event){$event.preventDefault();return _vm.jump2page.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }